import { Heading, Icon, Link, Skeleton, Stack, Table, Tbody, Text } from '@ecoinvent/ui';
import { FiExternalLink } from 'react-icons/fi';
import { useParams } from 'react-router';

import AppCard from 'components/UI/AppCard';
import NoResultCard from 'components/UI/NoResultCard';
import useFlows from 'hooks/data/datasets/V4/flows/useFlows';

import FlowsView from './FlowsView';

type Props = {
  isLoading?: boolean;
};

const Flows = ({ isLoading }: Props) => {
  const { spold_id } = useParams();

  const { data, isLoading: areExchangesLoading } = useFlows(spold_id);

  const isAnythingLoading = isLoading || areExchangesLoading;

  const ecosphereFlows = data?.ecosphere ?? { inputs: [], outputs: [] };
  const technosphereFlows = data?.technosphere ?? { inputs: [], outputs: [] };

  return (
    <AppCard>
      <Stack>
        <Skeleton alignSelf={'flex-start'} isLoaded={!isAnythingLoading}>
          <Heading as={'h4'} fontSize={'xl'}>
            Flows
          </Heading>
        </Skeleton>
        <Skeleton alignSelf={'flex-start'} isLoaded={!isAnythingLoading}>
          <Text>
            Flows are amounts of a material, energy, or a substance that are transferred between two activities or between an
            activity and the environment.{' '}
            <Link href="https://support.ecoinvent.org/database" isExternal>
              Learn more about flows <Icon as={FiExternalLink} />
            </Link>
          </Text>
        </Skeleton>
      </Stack>
      {!isAnythingLoading && !data ? (
        <Table>
          <Tbody>
            <NoResultCard>No Results Found</NoResultCard>
          </Tbody>
        </Table>
      ) : (
        <FlowsView technosphereFlows={technosphereFlows} ecosphereFlows={ecosphereFlows} datasetId={spold_id as string} />
      )}
    </AppCard>
  );
};

export default Flows;
